import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { DatosContactoForm } from '@app/components/auth/DatosContactoForm/DatosContactoForm';

const DatosContactoPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('Datos de contacto')}</PageTitle>
      <DatosContactoForm />
    </>
  );
};

export default DatosContactoPage;
